import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

const DROP_CART_ITEM_MUTATION = gql`
  mutation DropCartItem($shopId: ID!, $productId: ID!) {
    dropCartItem(shop_id: $shopId, product_id: $productId)
  }
`

export interface DropCartItemVariables {
  shopId: GQL_ID
  productId: GQL_ID
}

export interface DropCartItemResponse {
  dropCartItem: boolean
}

export function useMutateDropCartItem () {
  return useMutation<DropCartItemResponse, DropCartItemVariables>(DROP_CART_ITEM_MUTATION)
}
